import LevelIndicator from './LevelIndicator';

export default LevelIndicator;
